import * as React from 'react';
import { isNonNullable } from '../_util/is';
import Alert from './Alert';
class ErrorBoundary extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            error: undefined,
            info: {},
        };
    }
    componentDidCatch(error, info) {
        this.setState({ error, info });
    }
    render() {
        const { message, title, description, id, children } = this.props;
        const { error, info } = this.state;
        const mergedTitle = title ?? message;
        const componentStack = info?.componentStack || null;
        const errorMessage = isNonNullable(mergedTitle) ? mergedTitle : error?.toString();
        const errorDescription = isNonNullable(description) ? description : componentStack;
        if (error) {
            return (React.createElement(Alert, { id: id, type: "error", title: errorMessage, description: React.createElement("pre", { style: { fontSize: '0.9em', overflowX: 'auto' } }, errorDescription) }));
        }
        return children;
    }
}
export default ErrorBoundary;
